import * as types from '../actions';

const initialState = {
  activity:'',
  data:'',
  status:0
};
export default function(state = initialState, action) {
    const response = action.response;
    switch(action.type) {
        
        case types.REFRESH_TOKEN_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    activity:types.REFRESH_TOKEN_SUCCESS,   
                    data:response.data,
                    status:response.status 
                }     
            }else{
                return {
                    ...state,                  
                    activity:types.REFRESH_TOKEN_ERROR,    
                    status:response.status     
                }   
            }             
        
        case types.REFRESH_TOKEN_ERROR:
            return {
                ...state,                  
                activity:types.REFRESH_TOKEN_ERROR,    
                status:response.status     
            }  

        default:
            return state;
    }
};